import { FC, useState, useCallback, useMemo, createRef, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { useDropzone, DropzoneRef } from 'react-dropzone'
import { default as Dzone } from 'react-dropzone'
import { ModalBox } from 'app/components/modals/ModalBox'

const baseStyle: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
}

const activeStyle = {
  borderColor: '#2196f3',
}

const acceptStyle = {
  borderColor: '#00e676',
}

const rejectStyle = {
  borderColor: '#ff1744',
}
const thumbsContainer: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
}

const thumb: React.CSSProperties = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
}

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
}

const img = {
  display: 'block',
  width: 'auto',
  height: '100%',
}

const thumbLayer: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
}
const thumbBg = {
  zIndex: 0,
  backgroundColor: '#f0f0f0',
  width: '100px',
  height: '100px',
  opacity: '0.5',
  transition: 'background 500ms',
}
const thumbBtn: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  zIndex: 1,
  width: '100px',
  height: '100px',
  transition: 'background 500ms',
}

export type DropZoneFile = {
  src: string
  file?: File
  fileName?: string
  frmDb: boolean
}

type Props = {
  maxFiles?: number
  fileState: DropZoneFile[]
  handlerOnDrop?: (files: DropZoneFile[]) => void
  handlerOnDelete?: (values: DropZoneFile[]) => void
  disabled?: boolean
}
const DropZone: FC<Props> = ({
  maxFiles = 3,
  fileState,
  handlerOnDrop,
  handlerOnDelete,
  disabled,
}) => {
  //const [files, setFiles] = useState<DropZoneFile[]>([])

  const [showLayer, setShowLayer] = useState(-1)
  const dropzoneRef = createRef<DropzoneRef>()
  const [viewImg, setViewImg] = useState<{ isShow: boolean; src: string }>({
    isShow: false,
    src: '',
  })

  //
  // useEffect(() => {
  //   defaultFiles && setFiles(defaultFiles)
  // }, [defaultFiles])

  // const onDrop = useCallback((acceptedFiles:any) => {   
  //   if (fileState.length + acceptedFiles.length > maxFiles) {
  //     alert(`max file equal ${maxFiles}`)
  //     return
  //   }
  //   const imgFiles: DropZoneFile[] = []
  //   acceptedFiles.forEach((file: any) => {
  //     imgFiles.push({
  //       src: URL.createObjectURL(file),
  //       file: file,
  //       frmDb: false,
  //     })
  //   }) 
  //   handlerOnDrop?.(imgFiles)    
  // }, [])
  const onDrop = (acceptedFiles: any) => {
    if (fileState.length + acceptedFiles.length > maxFiles) {
      alert(`max file equal ${maxFiles}`)
      return
    }
    const imgFiles: DropZoneFile[] = []
    acceptedFiles.forEach((file: any) => {
      imgFiles.push({
        src: URL.createObjectURL(file),
        file: file,
        frmDb: false,
      })
    })
    handlerOnDrop?.(imgFiles)
  }

  const onReject = (rejected: any) => {
    if (rejected.length > maxFiles) {
      alert(`max file equal ${maxFiles}`)
    }
  }

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png'],
    },
    maxFiles: maxFiles,
    multiple: true,
    onDrop: onDrop,
    onDropRejected: onReject,
    disabled: disabled,
  })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  )
  const onDeletePreview = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, src: string) => {
    e.preventDefault()
    if (disabled && disabled === true) return
    const imgs = fileState.filter((n) => n.src !== src)
    handlerOnDelete?.(imgs)
    //setFiles(imgs)
  }
  const onEdit = (e: any) => {
    e.preventDefault()
    if (disabled) return false
    dropzoneRef.current?.open()
  }
  const handleViewImg = (e: any, src: string) => {
    e.preventDefault()
    setViewImg({
      isShow: true,
      src: src,
    })
  }

  const onEditDrop = (files: any) => {
    if (disabled === true) return false
  }

  const thumbs = fileState.map((file, index: number) => (
    <div className='' key={index}>
      {!disabled && (
        <>
          <div
            className='card-toolbar d-flex justify-content-end '
            onClick={(e) => onDeletePreview(e, file.src)}
          >
            <div
              style={{ zIndex: 2 }}
              className='btn btn-sm btn-icon btn-light-primary position-absolute  '
            >
              <KTSVG
                className='svg-icon svg-icon-2 '
                path='/media/icons/duotune/arrows/arr061.svg'
              />
            </div>
          </div>
        </>
      )}
      <div
        onMouseEnter={(e) => {
          setShowLayer(index)
        }}
        onMouseLeave={(e) => {
          setShowLayer(-1)
        }}
      >
        <div style={showLayer === index ? thumbLayer : { display: 'none' }}>
          <div style={thumbBg}></div>
          <div style={thumbBtn}>
            <Dzone
              ref={dropzoneRef}
              multiple={false}
              noKeyboard={true}
              noDrag={true}
              onDrop={onEditDrop}
              noClick={true}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {!disabled && (
                    <>
                      <button
                        className='btn btn-sm btn-icon btn-light me-2'
                        onClick={(e) => onEdit(e)}
                      >
                        edit
                      </button>
                      <button
                        className='btn btn-sm btn-icon btn-light'
                        onClick={(e) => handleViewImg(e, file.src)}
                      >
                        view
                      </button>
                    </>
                  )}
                </div>
              )}
            </Dzone>
          </div>
        </div>
        <div style={thumb}>
          <div style={thumbInner}>
            <img src={file.src} style={img} alt='' />
          </div>
        </div>
      </div>
    </div>
  ))

  return (
    <>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <p>Drag 'n' drop some files here, or click to select files</p>
        )}
      </div>
      <aside style={thumbsContainer}>{thumbs}</aside>
      {viewImg.isShow && (
        <ModalBox
          title={'Preview'}
          stateShow={viewImg.isShow}
          onHide={() => setViewImg({ ...viewImg, isShow: false })}
          showOK={false}
          txtCancel='Close'
          showCancel={true}
        >
          <div className='d-flex justify-content-center'>
            <img src={viewImg.src} alt=''></img>
          </div>
        </ModalBox>
      )}
    </>
  )
}

export { DropZone }
